module.exports = __webpack_public_path__ + "assets/img/smartTV2-icon4.5749b838.svg";